import React, { Component } from 'react';
import { WebGLRenderer, CanvasRenderer, PerspectiveCamera, Scene, TextureLoader, LinearFilter, SphereGeometry, Mesh, MeshBasicMaterial } from 'three';
import R from 'ramda';

import OrbitControls from './OrbitControls.js';
import { changedKeys } from './Utils.js';


const webgl = (() => {
    try {
	var canvas = document.createElement( 'canvas' );
	return !! (window.WebGLRenderingContext && (canvas.getContext('webgl') || canvas.getContext('experimental-webgl')));
    } catch(e) {
	return false;
    }
})();

class Photosphere extends Component {
    constructor(props) {
        super(props);

        this.state = {
            h: 600, // TODO parameterize
            w: 800,
            camera: {
                fov: 100,
                near: 1,
                far: 1000
            }
        };

        this.camera = new PerspectiveCamera(
            this.state.camera.fov,
            this.state.w / this.state.h,
            this.state.camera.near,
            this.state.camera.far
        );
        this.camera.position.x = 0.1;
        this.camera.position.y = 0;

        this.scene = new Scene();

        this.controls = new OrbitControls(this.camera);
	this.controls.noPan = true;
	this.controls.noZoom = true;
	this.controls.autoRotate = true;
	this.controls.autoRotateSpeed = 0.5;

        this.renderScene    = this.renderScene.bind(this);
        this.updateControls = this.controls.update.bind(this);
    }

    updateScene(src) {
        if(this.sphere) {
            this.scene.remove(this.sphere);
        }

        const textureLoader = new TextureLoader();
        const texture = textureLoader.load(src, this.renderScene);
        // texture.minFilter = LinearFilter;

        this.sphere = new Mesh(
	    new SphereGeometry(100, 20, 20), // TODO: Parameterize
	    new MeshBasicMaterial({
		map: texture
	    })

	);

	this.sphere.scale.x = -1;
	this.scene.add(this.sphere);
    }

    renderScene() {
        this.renderer.render(this.scene, this.camera);
        this.props.onComplete();
    }

    componentDidMount() {
        const rendererOptions = {
            canvas: this.refs.PhotosphereCanvas
        }

        this.updateScene(this.props.src);
        this.renderer = webgl ? new WebGLRenderer(rendererOptions) : new CanvasRenderer(rendererOptions);

        window.requestAnimationFrame(this.updateControls);
	this.controls.update();
        this.controls.addEventListener('change', this.renderScene);
    }

    componentWillReceiveProps(nextProps) {
        if(R.equals(changedKeys(this.props, nextProps), ["src"])) {
            this.updateScene(nextProps.src);
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        if(R.equals(changedKeys(this.props, nextProps), ["src"]) && changedKeys(this.state, nextState).length === 0) {
            return false;
        } else {
            return true;
        }
    }

    render() {
        return (
                <canvas ref="PhotosphereCanvas" id="PhotosphereCanvas" width={this.state.w} height={this.state.h} style={{width: this.state.w + "px", height: this.state.h + "px"}}></canvas>
        );
    }
}

export default Photosphere;



/** WEBPACK FOOTER **
 ** ./src/Photosphere.js
 **/